/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_SuccessInputs */

const cs_youtube_export_success = /** @type {(inputs: Youtube_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video nahráno a odkaz uložen.`)
};

const en_youtube_export_success = /** @type {(inputs: Youtube_Export_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video uploaded and link saved.`)
};

/**
* | output |
* | --- |
* | "Video uploaded and link saved." |
*
* @param {Youtube_Export_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_success = /** @type {((inputs?: Youtube_Export_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_success(inputs)
	return cs_youtube_export_success(inputs)
});